// extracted by mini-css-extract-plugin
export default {"svgIcon":"discoverFieldIcons_svgIcon__yX2DP","adornmentTight":"discoverFieldIcons_adornmentTight__l4SXC"};